import { cx } from '@emotion/css';
import { Stack } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { useForm } from '@mantine/form';
import { modals } from '@mantine/modals';
import { IconBombFilled } from '@tabler/icons-react';
import { ModalFooter } from 'components/ModalFooter';
import { superButtonStyles } from 'components/SuperButton';
import { i18nKeys, useTranslation } from 'locales';
import { useUpdateInvoiceDates } from 'shared/hooks/use-update-invoice-dates';

interface UpdateDateFormProps {
  issueDate: string;
  dueDate: string;
  invoiceId: string;
  refreshInvoice: VoidFunction;
}

export const UpdateDatesForm = ({
  issueDate,
  dueDate,
  invoiceId,
  refreshInvoice,
}: UpdateDateFormProps) => {
  const { t } = useTranslation();

  const { updateInvoiceDates } = useUpdateInvoiceDates();

  const form = useForm({
    initialValues: {
      issueDate,
      dueDate,
    },
  });

  const handleSubmit = () => {
    updateInvoiceDates(
      { id: invoiceId, ...form.values },
      {
        onSuccess: () => {
          form.reset();
          modals.closeAll();
          refreshInvoice();
        },
      },
    );
  };

  return (
    <>
      <Stack gap="sm">
        <DateInput label={t(i18nKeys.ISSUE_DATE)} {...form.getInputProps('issueDate')} />
        <DateInput label={t(i18nKeys.DUE_DATE)} {...form.getInputProps('dueDate')} />
      </Stack>
      <ModalFooter
        onCancel={() => {
          modals.closeAll();
          form.reset();
        }}
        onSave={handleSubmit}
        onSaveProps={{
          variant: 'gradient',
          className: cx(superButtonStyles.gradientHover, superButtonStyles.alwaysAnimate),
          leftSection: <IconBombFilled size={18} stroke={1.5} />,
        }}
      />
    </>
  );
};
